var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", [
    _c(
      "ul",
      { staticClass: "pagination" },
      [
        _c("li", { class: { disabled: _vm.links.previous === undefined } }, [
          _c(
            "a",
            {
              attrs: { href: "#", "aria-label": "Previous" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.prevPage()
                }
              }
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("«")])]
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.pagesWindow, function(page) {
          return _c(
            "li",
            { class: { active: _vm.pagination.current_page === page } },
            [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.setPage(page)
                    }
                  }
                },
                [_vm._v(_vm._s(page))]
              )
            ]
          )
        }),
        _vm._v(" "),
        _c("li", { class: { disabled: _vm.links.next === undefined } }, [
          _c(
            "a",
            {
              attrs: { href: "#", "aria-label": "Next" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.nextPage()
                }
              }
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("»")])]
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f6e5bf1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f6e5bf1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pagination.vue
// module id = 650
// module chunks = 72